import React from "react";
import classes from "./DeletePublisherModal.module.css";
import Spinner from "./Spinner";

const DeletePublisherModal = ({ setDeletePublisherModal, publisherName , deleteLoading , deletePublisher}) => {
    return (
        <div className={classes.container} onClick={() => setDeletePublisherModal({state:false,details:null})}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.info}>
                    <img
                        src="/assets/images/warning.png"
                        alt="warning"
                        className={classes.img}
                    />
                </div>
                <div className={classes.msg}>
                    <p className={classes.text}>Delete '{publisherName}'
                    </p>
                    <p className={classes.text}>Are you sure you want to delete this Publisher?</p>
                </div>
                <div className={classes.btns_container}>
                    <button className={classes.btn} type="button"
                    disabled={deleteLoading}
                    onClick={deletePublisher}
                    >
                        {deleteLoading ? <Spinner /> : "Yes"}
                    </button>
                    <button
                        className={classes.btn_2}
                        type="button"
                        disabled={deleteLoading}
                        onClick={()=>setDeletePublisherModal({state:false,details:null})}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeletePublisherModal;